import { render, staticRenderFns } from "./PayItemEdit.vue?vue&type=template&id=20564fea"
import script from "./PayItemEdit.vue?vue&type=script&lang=js"
export * from "./PayItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports